import { observable } from "mobx";
import { dispatchable, ActionStore } from "higher-order/ActionStore";

export default class RecaptchaStore extends ActionStore {
    @observable hasCaptchaToken;

    constructor(props, dispatcher) {
        super(dispatcher);
        this.recaptchaSiteKey = props.recaptchaSiteKey;
        this.hasCaptchaToken = false;
    }

    @dispatchable
    setCaptchaToken(e) {
        this.hasCaptchaToken = true;
        e.data.formModel.data.set("responseToken", e.data.response);
    }

    @dispatchable
    clearCaptchaToken(e) {
        this.hasCaptchaToken = false;
        e.data.formModel.data.delete("responseToken");
    }
}